import { createConnector } from 'wagmi';
import { coinbaseWallet as coinbaseWagmiWallet } from 'wagmi/connectors';
import { icon } from './coinbaseIcon.js';
import { hasInjectedProvider } from '../../../utils/getInjectedConnector.js';
export const coinbaseWallet = ({ appName, appIcon }) => {
    const isCoinbaseInjected = hasInjectedProvider({ flag: 'isCoinbaseWallet' });
    const getUri = (uri) => uri;
    return {
        id: 'coinbase',
        name: 'Coinbase Wallet',
        rdns: 'com.coinbase.wallet',
        iconUrl: icon,
        // Note that we never resolve `installed` to `false` because the
        // Coinbase Wallet SDK falls back to other connection methods if
        // the injected connector isn't available
        installed: isCoinbaseInjected,
        isExtension: true,
        isMobile: true,
        downloadUrl: 'https://www.coinbase.com/wallet/downloads',
        getUri,
        createConnector: (walletDetails) => createConnector(config => (Object.assign(Object.assign({}, coinbaseWagmiWallet({
            version: '4',
            appName,
            appLogoUrl: appIcon,
            preference: 'eoaOnly',
        })(config)), walletDetails))),
    };
};
